import * as tslib_1 from "tslib";
import { getStore as getSharedFavoritesStore } from 'owa-favorites';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
export default function getFavoriteIdForPersona(personaId, emailAddress) {
    return personaId
        ? getFavoritePersonaByPersonaId(personaId)
        : getFavoritePersonaByEmail(emailAddress);
}
function getFavoritePersonaInfo() {
    var favoriteStore = getSharedFavoritesStore();
    return isControlFeatureEnabled('tri-favorites-roaming')
        ? tslib_1.__spread(favoriteStore.outlookFavoritePersonas.values()).map(function (f) { return ({
            favoriteId: f.favoriteId,
            allEmailAddresses: f.allEmailAddresses,
            personaId: f.personaId,
        }); })
        : tslib_1.__spread(favoriteStore.favoritesPersonaNodes.values()).map(function (f) { return ({
            favoriteId: f.id,
            allEmailAddresses: f.allEmailAddresses,
            personaId: f.personaId,
        }); });
}
function getFavoritePersonaByPersonaId(personaId) {
    var info = getFavoritePersonaInfo().filter(function (node) { return node.personaId && node.personaId === personaId; });
    if (info && info.length > 0) {
        return info[0].favoriteId;
    }
    return undefined;
}
function getFavoritePersonaByEmail(emailAddress) {
    var info = getFavoritePersonaInfo().filter(function (node) {
        return node.allEmailAddresses &&
            node.allEmailAddresses.some(function (email) { return emailAddress.toLocaleLowerCase() === email.toLocaleLowerCase(); });
    });
    if (info && info.length > 0) {
        return info[0].favoriteId;
    }
    return undefined;
}
//# sourceMappingURL=getFavoritePersona.js.map